export const ENABLED_FEATURES = 'enabledFeatures';

const featureFlagSwitcher = (name: string) => {
  const storedFeatures = globalThis.localStorage?.getItem(ENABLED_FEATURES) ?? '';
  const enabledFeatures = storedFeatures ? JSON.parse(storedFeatures) : [];

  const featureFlag = new URLSearchParams(globalThis.location?.search).get(name);
  const flagIndex = enabledFeatures.indexOf(name);

  if (featureFlag === 'true' && flagIndex === -1) {
    enabledFeatures.push(name);
  }
  if (featureFlag === 'false' && flagIndex > -1) {
    enabledFeatures.splice(flagIndex, 1);
  }
  globalThis.localStorage?.setItem(ENABLED_FEATURES, JSON.stringify(enabledFeatures));

  return Boolean(enabledFeatures.includes(name));
};

export default featureFlagSwitcher;
